import { render, staticRenderFns } from "./topMatchTable.vue?vue&type=template&id=0ac0d98a&scoped=true&"
import script from "./topMatchTable.vue?vue&type=script&lang=js&"
export * from "./topMatchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0d98a",
  null
  
)

export default component.exports